const PATHS = {
  search:        'M11 11l4 4M7.5 13a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Z',
  calendar:      'M4 7h12M6 3v3M12 3v3M4 6h12v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6Z',
  clock:         'M9 5v4l2.5 1.5M14.5 9a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z',
  pin:           'M9 16s5-5.2 5-9a5 5 0 1 0-10 0c0 3.8 5 9 5 9ZM9 9.5A1.5 1.5 0 1 0 9 6.5a1.5 1.5 0 0 0 0 3Z',
  user:          'M9 9.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 15.5c.8-2.6 3-4 5.5-4s4.7 1.4 5.5 4',
  heart:         'M9 15s-5.5-3.3-5.5-7A3 3 0 0 1 9 6a3 3 0 0 1 5.5 2c0 3.7-5.5 7-5.5 7Z',
  menu:          'M3 6h14M3 10h14M3 14h14',
  close:         'M4 4l12 12M16 4L4 16',
  arrow_right:   'M4 10h12M11 5l5 5-5 5',
  arrow_left:    'M16 10H4M9 5l-5 5 5 5',
  chevron_right: 'M7 4l6 6-6 6',
  chevron_down:  'M4 7l6 6 6-6',
  plus:          'M10 4v12M4 10h12',
  check:         'M4 10l4 4 8-8',
  star:          'M10 3l2 4.5 5 .6-3.7 3.4 1 4.9L10 13.9 5.7 16.4l1-4.9L3 8.1l5-.6L10 3Z',
  filter:        'M4 5h12M6 10h8M8 15h4',
  flame:         'M10 16c3 0 5-2 5-5 0-3-3-4-3-7 0 0-4 2-4 5 0-1.5-1-2-1-2s-2 2-2 4c0 3 2 5 5 5Z',
  map:           'M3 5l5-2 5 2 5-2v12l-5 2-5-2-5 2V5ZM8 3v14M13 5v14',
  hotel:         'M3 15V7h14v8M3 11h14M7 11V9M13 11V9M3 15h14',
  temple:        'M10 2l6 4H4l6-4ZM5 6v3h10V6M5 9h10v7H5V9ZM9 12v4M11 12v4',
  water:         'M3 13c2 0 2-2 4-2s2 2 4 2 2-2 4-2M3 9c2 0 2-2 4-2s2 2 4 2 2-2 4-2M3 17c2 0 2-2 4-2s2 2 4 2 2-2 4-2',
  flower:        'M10 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM10 6V3M10 14v-4M10 10l-3-2M10 10l3-2M10 10l-3 2M10 10l3 2M6 8l-3 0M14 8l3 0M6 12l-3 3M14 12l3 3',
  globe:         'M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 10h16M10 2c2 2.5 3 5.3 3 8s-1 5.5-3 8M10 2c-2 2.5-3 5.3-3 8s1 5.5 3 8',
  bell:          'M5 14V9a4 4 0 0 1 8 0v5l1.5 2h-11L5 14ZM7.5 16a1.5 1.5 0 0 0 3 0',
  sun:           'M9 3v1M9 14v1M3 9h1M14 9h1M4.5 4.5l.7.7M12.8 12.8l.7.7M4.5 13.5l.7-.7M12.8 5.2l.7-.7M9 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z',
  moon:          'M14 11a5 5 0 0 1-6-7 5 5 0 1 0 6 7Z',
  sparkle:       'M10 3l1.3 3.7L15 8l-3.7 1.3L10 13l-1.3-3.7L5 8l3.7-1.3L10 3Z',
  mic:           'M9 3a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2ZM5 9a4 4 0 0 0 8 0M9 13v3M7 16h4',
  bookmark:      'M5 3h8v13l-4-2.5L5 16V3Z',
  share:         'M13 6l3-3 3 3M16 3v10M6 9v5a2 2 0 0 0 2 2h8',
  info:          'M9 9v4M9 6v.01M9 17a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z',
  sort:          'M6 4v12M6 4l-2 2M6 4l2 2M14 16V4M14 16l-2-2M14 16l2-2',
  wifi:          'M1 7a12 12 0 0 1 16 0M4 10a8 8 0 0 1 10 0M6.5 12.5a4 4 0 0 1 5 0M9 15v.01',
  car:           'M3 12v-2l1.5-4A2 2 0 0 1 6.4 5h5.2a2 2 0 0 1 1.9 1l1.5 4v2M3 12h12M3 12v2h2v-2M13 12v2h2v-2M6 9h6',
  food:          'M5 8h8a4 4 0 0 1-8 0ZM9 4v4M3 16h12',
  parking:       'M6 4h4a3 3 0 1 1 0 6H6V4ZM6 4v12',
  spa:           'M9 3c2 2 3 5 0 8M9 3c-2 2-3 5 0 8M9 11c-3 0-5 2-5 5M9 11c3 0 5 2 5 5',
  shield:        'M9 2l6 2v5c0 4-2.5 6.5-6 8-3.5-1.5-6-4-6-8V4l6-2Z',
  logout:        'M11 15l4-4-4-4M15 11H6M9 4H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h4',
  login:         'M8 4H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3M11 15l4-4-4-4M15 11H7',
  settings:      'M9 3a6 6 0 1 0 0 12A6 6 0 0 0 9 3ZM9 7v2M9 10h.01',
  list:          'M4 6h12M4 10h12M4 14h8',
  grid:          'M4 4h4v4H4ZM10 4h4v4h-4ZM4 10h4v4H4ZM10 10h4v4h-4Z',
  edit:          'M11 4l3 3-9 9H2v-3l9-9ZM9.5 5.5l3 3',
  trash:         'M4 6h12M8 6V4h4v2M9 10v5M11 10v5M5 6l1 11h8l1-11',
  home:          'M3 10l7-7 7 7v7H3V10ZM8 17v-5h4v5',
};

export default function Icon({ name, size = 16, stroke = 'currentColor', fill = 'none', strokeWidth = 1.5, className = '', style = {} }) {
  const d = PATHS[name];
  if (!d) return <span style={{ width: size, height: size, display: 'inline-block' }} />;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: 'none', verticalAlign: 'middle', ...style }}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
